import React, { useEffect, useState } from 'react';
import { TextField as MuiTextField, TextFieldProps, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTheme } from '../../../../../providers/custom-theme-provider';
import { colorPalette } from '../../../../myde-react-components';
interface StyleProps {
  currentThemes: Theme;
}
interface CustomProps {
  isOptional?: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>({
  textField: {
    '& .MuiInputLabel-formControl': {
      '&.Mui-focused': {
        color: ({ currentThemes }) => `${currentThemes.palette.primary.main}`,
      },
      '&.Mui-error': {
        color: `${colorPalette.error} !important`,
      },
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused': {
        '& > fieldset': { borderColor: ({ currentThemes }) => `${currentThemes.palette.primary.main} !important` },
      },
      '&.Mui-error': {
        '& > fieldset': {
          borderColor: `${colorPalette.error} !important`,
        },
        '&.Mui-focused': {
          '& > fieldset': {
            borderColor: `${colorPalette.error} !important`,
          },
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        '& legend': {
          display: 'none !important',
        },
      },
    },
    '& .MuiOutlinedInput-input.MuiInputBase-input': {
      padding: '30px 16px 10px 16px',
    },
  },
});

export type CombinedProps = CustomProps & TextFieldProps;

export const TextField = React.forwardRef<any, CombinedProps>(({ isOptional, ...props }: CombinedProps, ref: any) => {
  const { currentThemes } = useTheme();
  const [label, setLabel] = useState('');

  useEffect(() => {
    if (props.label) {
      setLabel(isOptional ? `${props.label} (optional)` : `${props.label}`);
    }
  }, []);

  const styleProps: StyleProps = {
    currentThemes: currentThemes,
  };

  const classes = useStyles(styleProps);

  return <MuiTextField {...props} label={label} className={classes.textField} ref={ref} />;
});
export default TextField;
